import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { EXPERIMENTS_TABLE_COLUMN, EXPERIMENTS_TABLE_COLUMNS } from './tableData';

export type ChooseCampaignTakeoverProps = {
  /** Callback function on takeover close. Normally used to refetch data on the base page */
  onClose: () => void;
};

export enum CHOOSE_CAMPAIGN_COLUMNS {
  id = 'ID',
  CAMPAIGN_NAME = 'CampaignName',
  STATUS = 'Status',
  CAMPAIGN_TYPE = 'CampaignType',
  MEDIUM = 'Medium',
  EXPERIMENT_NAME = 'ExperimentName',
  LAST_MODIFIED = 'LastModified',
  ACTION_MENU = 'ACTION_MENU',
}

export enum CHOOSE_CAMPAIGN_COLUMN_SORT_ENUM {
  CAMPAIGN_NAME = 'Name',
  STATUS = 'State',
  MEDIUM = 'MessageMedium',
  LAST_MODIFIED = 'UpdatedAt',
}

export type CHOOSE_CAMPAIGN_TABLE_COLUMN = {
  id: CHOOSE_CAMPAIGN_COLUMNS;
  label: string;
  isSortable: boolean;
  initialSortDirection: SORT_DIRECTIONS;
  isRightAligned: boolean;
};

export type ColumnType = EXPERIMENTS_TABLE_COLUMN | CHOOSE_CAMPAIGN_TABLE_COLUMN;
export type TableColumnsType = EXPERIMENTS_TABLE_COLUMNS | CHOOSE_CAMPAIGN_COLUMNS;

export type ChooseCampaignTableRow = {
  id: string;
  campaignName: string;
  status: string;
  campaignType: string;
  medium: string;
  experimentName: string;
  lastModified: string;
};
